<template>
    <div class="page-class"
        v-if="isAccountLoaded">
        <div class="page-wrapper">
            <div class="page-content">
                <NavbarDetail
                        :lbl="lbl.detail"
                        :isShowInfo="isAccountLoaded && isShowNavInfo"
                        :navName="navbarName"
                        :userType="userType"
                        :profile="profile"
                        :userPoint="point"
                        :busNav="busNav"
                        @clickBack="clickBack" />
                <keep-alive>
                    <router-view :key="$route.fullPath"></router-view>
                </keep-alive>
            </div>

            <div class="page-bg page-bg-white"></div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import NavbarDetail from '@/components/Layout/NavBar/NavBarDetail.vue';
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: "Privilege",
    mixins: [AccountMixin, LocaleMixin],
    components: { NavbarDetail },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    watch: {
        $route(to) {
            this.setIsList(to);
        }
    },
    data: function () {
        return {
            //page
            isList: true,
            isShowNavInfo: true,

            busNav: new Vue(),
            navbarName: '',

            trackingService: new TrackingService(this),
            trackingCate: 'campaigndetail_page'
        };
    },
    created: function () {
        this.setIsList(this.$route);
        this.trackingService.screenName('campaigndetail');
        this.trackingService.event(this.trackingCate, 'view_campaigndetail');
    },
    methods: {
        //event
        clickBack: function () {
            this.trackingService.event(this.trackingCate, 'click_back');
            if (this.isList)
                this.$router.push('/');
            else
                this.$router.back();
        },
        setIsList: function (to) {
            this.isList = (to.name == 'privilegelist');
            this.navbarName = this.isList ? this.lbl.reward.title_privilege : this.lbl.detail.navbar_detail_name;
        }
    }
}
</script>
